import * as reducers from './reducers'

export const constants = {
  NAME: 'responses'
}

export default { constants, reducers}